export default {
    name: 'formprobase',
    data () {
        return {
            dafaultRightSpan:2,
            dafaultLeftSpan:1,
            rightSpan:2,
            mainSpan:21,
            leftSpan:1,
            rightShowFlag:true,
            leftShowFlag:true,
        };
    },
    methods:{
        doShowRight() {
            this.rightShowFlag = true;
            this.rightSpan = this.dafaultRightSpan; 
            this.mainSpan = 24 -this.rightSpan - this.toolSpan;
        },
        doHideRight() {
            this.rightShowFlag = false;
            this.rightSpan = 0; 
            this.mainSpan = 24 -this.rightSpan - this.leftSpan;
        },
        doShowLeft() {
            this.leftShowFlag = true;
            this.leftSpan = this.dafaultLeftSpan; 
            this.mainSpan = 24 -this.rightSpan - this.leftSpan;
        },
        doHideLeft() {
            this.leftShowFlag = false;
            this.leftSpan = 0; 
            this.mainSpan = 24 -this.rightSpan - this.leftSpan;
        },
        doAction(para) {
            this.$emit('doAction', para);
        },
        changedStatus(value) {
            this.$refs.tool.changedStatus(value);
        },
        gridChangedStatus(name,value) {
            this.$refs.tool.gridChangedStatus(name,value);
        },
       
    }
};


// WEBPACK FOOTER //
// ./src/components/form/toolanchor.js